/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiHealthCheckDto } from '../models/api-health-check-dto';
import { appControllerApiHealthCheck } from '../fn/app/app-controller-api-health-check';
import { AppControllerApiHealthCheck$Params } from '../fn/app/app-controller-api-health-check';
import { appControllerHealthCheck } from '../fn/app/app-controller-health-check';
import { AppControllerHealthCheck$Params } from '../fn/app/app-controller-health-check';

@Injectable({ providedIn: 'root' })
export class AppService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appControllerHealthCheck()` */
  static readonly AppControllerHealthCheckPath = '/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHealthCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHealthCheck$Response(params?: AppControllerHealthCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = appControllerHealthCheck(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHealthCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHealthCheck(params?: AppControllerHealthCheck$Params, context?: HttpContext): Observable<string> {
    const resp = this.appControllerHealthCheck$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `appControllerApiHealthCheck()` */
  static readonly AppControllerApiHealthCheckPath = '/api/api/health-check';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerApiHealthCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerApiHealthCheck$Response(params?: AppControllerApiHealthCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiHealthCheckDto>> {
    const obs = appControllerApiHealthCheck(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerApiHealthCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerApiHealthCheck(params?: AppControllerApiHealthCheck$Params, context?: HttpContext): Observable<ApiHealthCheckDto> {
    const resp = this.appControllerApiHealthCheck$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ApiHealthCheckDto>): ApiHealthCheckDto => r.body)
    );
  }

}
